<!-- Header -->
<div
  *ngIf="queryParams$ | async as queryParams"
  class="header-container tw-mb-4">
  <mg-form-date-range
    class="date-range-input"
    [value]="{
      start: queryParams.start_date,
      end: queryParams.end_date
    }"
    (valueChange)="rangeChanged($event)">
  </mg-form-date-range>
  <mg-form-text-input
    class="title-search-input"
    iconRight="search"
    [label]="MSG.FIELD_LABEL_SEARCH"
    [isClearable]="true"
    [value]="queryParams.title"
    (valueChange)="titleChange($event)">
  </mg-form-text-input>
  <mg-btn
    *ngIf="canEdit$ | async"
    class="tw-flex tw-shrink-0 md:tw-ml-auto"
    variant="filled"
    [wide]="true"
    [responsive]="true"
    (pressed)="flexPeriods.openModal()">
    {{ MSG.BUTTON_LABEL_NEW }}
  </mg-btn>
</div>

<!-- Table -->
<mat-table
  matSort
  class="list-table flexible-mobile-layout"
  [dataSource]="dataSource"
  [trackBy]="trackById">
  <!-- Title Column -->
  <ng-container matColumnDef="title">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      mgSortHeader
      class="w-sm-flex"
      [activeColumnKey]="activeSortColumn$ | async"
      (click)="selectActiveColumn('title')">
      <mg-text
        class="column-header"
        textAlign="left"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_TITLE }}
      </mg-text>
    </mat-header-cell>
    <mat-cell
      *matCellDef="let item"
      class="w-sm-flex">
      <mg-text
        variant="body-md"
        textAlign="left"
        matTooltipClass="mg-tooltip"
        [matTooltip]="item.title"
        [numberOfLines]="2">
        {{ item.title }}
      </mg-text>
    </mat-cell>
  </ng-container>

  <!-- Date Column -->
  <ng-container matColumnDef="date">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      mgSortHeader
      [activeColumnKey]="activeSortColumn$ | async"
      (click)="selectActiveColumn('date')">
      <mg-text
        class="column-header"
        textAlign="left"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_DATE }}
      </mg-text>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <mg-text
        variant="body-md"
        textAlign="left"
        matTooltipClass="mg-tooltip">
        {{ item.date | date: 'mediumDate' }}
      </mg-text>
    </mat-cell>
  </ng-container>

  <!-- Time Column -->
  <ng-container matColumnDef="time">
    <mat-header-cell *matHeaderCellDef>
      <mg-text
        class="column-header"
        textAlign="left"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_TIME }}
      </mg-text>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <mg-text
        variant="body-md"
        textAlign="left"
        matTooltipClass="mg-tooltip">
        {{ item | formatTimeRange }}
      </mg-text>
    </mat-cell>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <mat-header-cell
      *matHeaderCellDef
      class="text-center">
      <mg-text
        class="column-header"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_STATUS }}
      </mg-text>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <mg-icon
        class="status-icon"
        matTooltipClass="mg-tooltip"
        [matTooltip]="
          item.enableActivityManagement
            ? EDIT_MSG.FIELD_LABEL_ACTIVITY_MANAGE_ENABLED
            : EDIT_MSG.FIELD_LABEL_ACTIVITY_MANAGE_DISABLED
        "
        [iconName]="item.enableActivityManagement ? PERIOD_LOCKS.ADD_UNLOCKED : PERIOD_LOCKS.ADD_LOCKED"
        [class.lock-open]="item.enableActivityManagement">
      </mg-icon>
      <mg-icon
        class="status-icon"
        matTooltipClass="mg-tooltip"
        [matTooltip]="
          item.enableStudentManagement && (item.teacherRegistrationDeadline | isInPast) === false
            ? EDIT_MSG.FIELD_LABEL_STUDENT_MANAGE_ENABLED
            : EDIT_MSG.FIELD_LABEL_STUDENT_MANAGE_DISABLED
        "
        [iconName]="
          item.enableStudentManagement && (item.teacherRegistrationDeadline | isInPast) === false
            ? PERIOD_LOCKS.TEACHER_UNLOCKED
            : PERIOD_LOCKS.TEACHER_LOCKED
        "
        [class.lock-open]="item.enableStudentManagement && (item.teacherRegistrationDeadline | isInPast) === false">
      </mg-icon>
      <mg-icon
        class="status-icon"
        matTooltipClass="mg-tooltip"
        [matTooltip]="
          item.enableStudentSelfManagement && (item.studentRegistrationDeadline | isInPast) === false
            ? EDIT_MSG.FIELD_LABEL_STUDENT_SELF_MANAGE_ENABLED
            : EDIT_MSG.FIELD_LABEL_STUDENT_SELF_MANAGE_DISABLED
        "
        [iconName]="
          item.enableStudentSelfManagement && (item.studentRegistrationDeadline | isInPast) === false
            ? PERIOD_LOCKS.STUDENT_UNLOCKED
            : PERIOD_LOCKS.STUDENT_LOCKED
        "
        [class.lock-open]="item.enableStudentSelfManagement && (item.studentRegistrationDeadline | isInPast) === false">
      </mg-icon>
    </mat-cell>
  </ng-container>

  <!-- Total Registered Column -->
  <ng-container matColumnDef="totalRegistered">
    <mat-header-cell *matHeaderCellDef>
      <mg-text
        class="column-header"
        textAlign="left"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_TOTAL_REGISTERED }}
      </mg-text>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <mg-text
        variant="body-md"
        textAlign="left"
        matTooltipClass="mg-tooltip">
        {{ item.activityInstances | totalRegistered }}
      </mg-text>
    </mat-cell>
  </ng-container>

  <!-- All Activities Column -->
  <ng-container matColumnDef="activities">
    <mat-header-cell
      *matHeaderCellDef
      class="text-center">
      <mg-text
        class="column-header"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_ALL_ACTIVITIES }}
      </mg-text>
    </mat-header-cell>
    <mat-cell
      *matCellDef="let item"
      class="text-center">
      <ng-container
        [ngTemplateOutlet]="allActivitiesButtonTemplate"
        [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- My Activities Column -->
  <ng-container matColumnDef="myActivities">
    <mat-header-cell
      *matHeaderCellDef
      class="text-center">
      <mg-text
        class="column-header"
        variant="label-md-secondary"
        color="outline">
        {{ MSG.COLUMN_LABEL_MY_ACTIVITIES }}
      </mg-text>
    </mat-header-cell>
    <mat-cell
      *matCellDef="let item"
      class="text-center">
      <ng-container
        [ngTemplateOutlet]="myActivitiesButtonTemplate"
        [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div class="tw-flex tw-gap-2">
        <mg-btn
          [id]="'flextime-periods-click-clone'"
          variant="icon"
          iconSet="minga"
          icon="mg-copy"
          (pressed)="clone(item.id)">
        </mg-btn>
        <mg-btn
          [id]="'flextime-periods-click-edit'"
          variant="icon"
          iconSet="minga"
          icon="mg-edit"
          (pressed)="flexPeriods.openModal(item.id)">
        </mg-btn>
      </div>
    </mat-cell>
  </ng-container>

  <!-- Mobile View -->
  <ng-container matColumnDef="mobile">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell
      *matCellDef="let item"
      class="mobile-layout">
      <mg-mobile-card [title]="item.title">
        <div class="tw-flex tw-flex-column tw-gap-1">
          <div class="tw-flex tw-flex-row tw-justify-between">
            <mg-text
              variant="label-md"
              color="surface-alt">
              {{ MSG.COLUMN_LABEL_DATE }}
            </mg-text>
            <mg-text variant="label-md">
              {{ item.date | date: 'mediumDate' }}
            </mg-text>
          </div>
          <div class="tw-flex tw-flex-row tw-justify-between">
            <mg-text
              variant="label-md"
              color="surface-alt">
              {{ MSG.COLUMN_LABEL_TIME }}
            </mg-text>
            <mg-text variant="label-md"> {{ item | formatTimeRange }}</mg-text>
          </div>
          <div class="tw-flex tw-flex-row tw-justify-between">
            <mg-text
              variant="label-md"
              color="surface-alt">
              {{ MSG.COLUMN_LABEL_TOTAL_REGISTERED }}
            </mg-text>
            <mg-text variant="label-md">
              {{ item.activityInstances | totalRegistered }}
            </mg-text>
          </div>
          <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
            <mg-text
              variant="label-md"
              color="surface-alt">
              {{ MSG.COLUMN_LABEL_ALL_ACTIVITIES }}
            </mg-text>
            <div>
              <ng-container
                [ngTemplateOutlet]="allActivitiesButtonTemplate"
                [ngTemplateOutletContext]="{ $implicit: item }">
              </ng-container>
            </div>
          </div>
          <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
            <mg-text
              variant="label-md"
              color="surface-alt">
              {{ MSG.COLUMN_LABEL_MY_ACTIVITIES }}
            </mg-text>
            <div>
              <ng-container
                [ngTemplateOutlet]="myActivitiesButtonTemplate"
                [ngTemplateOutletContext]="{ $implicit: item }">
              </ng-container>
            </div>
          </div>
          <div
            *ngIf="'FLEX_TIME_MANAGE' | hasPermission"
            class="tw-flex tw-flex-row tw-justify-between">
            <mg-btn
              [id]="'flextime-periods-click-clone'"
              variant="icon"
              iconSet="minga"
              icon="mg-copy"
              (pressed)="clone(item.id)">
            </mg-btn>
            <mg-btn
              [id]="'flextime-periods-click-edit'"
              variant="icon"
              iconSet="minga"
              icon="mg-edit"
              (pressed)="flexPeriods.openModal(item.id)">
            </mg-btn>
          </div>
        </div>
      </mg-mobile-card>
    </mat-cell>
  </ng-container>

  <mat-header-row
    *matHeaderRowDef="displayedColumns$ | async"
    [fxHide]="(flexPeriods.isLoadingPeriods$ | async) === false && showEmptyState">
  </mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns$ | async"> </mat-row>
</mat-table>

<!-- Loading -->
<div
  *ngIf="flexPeriods.isLoadingPeriods$ | async"
  class="loading-container">
  <mg-spinner
    [diameter]="40"
    [thickness]="3">
  </mg-spinner>
</div>

<!-- Empty state -->
<ng-container
  *ngIf="(flexPeriods.isLoadingPeriods$ | async) === false && showEmptyState"
  [ngTemplateOutlet]="noResultsTemplate">
</ng-container>

<!-- Activities Button Template -->
<ng-template
  #allActivitiesButtonTemplate
  let-item>
  <mg-btn
    *ngIf="queryParams$ | async as queryParams"
    variant="filled"
    size="small"
    iconSet="minga"
    iconRight="mg-chevron-right"
    (pressed)="goToActivities(item, queryParams)">
    {{ item.activityInstances | countActivityInstances }}
  </mg-btn>
</ng-template>

<!-- My Activities Button Template -->
<ng-template
  #myActivitiesButtonTemplate
  let-item>
  <ng-container *ngIf="queryParams$ | async as queryParams">
    <mg-btn
      *ngIf="(item.activityInstances | countActivityInstances: authInfo.authPersonHash) > 0; else noInstanceTemplate"
      variant="filled"
      size="small"
      iconSet="minga"
      iconRight="mg-chevron-right"
      [disabled]="isInPast(item) || ((canEdit$ | async) === false && !item.enableActivityManagement)"
      (pressed)="openMyActivityEdit(item, queryParams)">
      1
    </mg-btn>

    <ng-template #noInstanceTemplate>
      <mg-btn
        variant="outlined"
        size="small"
        [disabled]="isInPast(item) || ((canEdit$ | async) === false && !item.enableActivityManagement)"
        (pressed)="openMyActivityEdit(item, queryParams)">
        {{ MSG.BUTTON_LABEL_ADD_ACTIVITY }}
      </mg-btn>
    </ng-template>
  </ng-container>
</ng-template>

<!-- Empty State Template -->
<ng-template #noResultsTemplate>
  <mg-empty-state
    [title]="MSG.EMPTY_STATE_TITLE"
    [subtitle]="MSG.EMPTY_STATE_SUBTITLE">
  </mg-empty-state>
</ng-template>
